
import Component from '../../../assets/scripts/modules/component'

class ArticleContentTableComponent extends Component {
  init () {
    this.richtext = this.element.querySelector('.richtext')
    this.table = this.element.querySelector('.richtext table')
    this.tbody = this.element.querySelector('.richtext tbody')
    this.link = this.element.querySelector('.article-content-table__footer-text .link')

    if (!this.richtext || !this.table || !this.tbody || !this.link) {
      return
    }

    this.link.addEventListener('click', this.onClick.bind(this))
    this.table.addEventListener('scroll', this.onScroll.bind(this))

    this.doMask()
  }

  onScroll () {
    this.link.removeEventListener('click', this.onClick.bind(this))
    this.table.removeEventListener('scroll', this.onScroll.bind(this))

    this.element.classList.add('article-content-table--scrolled')

    this.doMask()
  }

  onClick () {
    this.table.scrollTo({ left: this.tbody.clientWidth, top: 0, behavior: 'smooth' })
  }

  doMask () {
    this.element.classList.remove('article-content-table--scroll-start')
    this.element.classList.remove('article-content-table--scroll-end')
    this.element.classList.remove('article-content-table--scrollable')

    if (this.table.scrollWidth === this.richtext.offsetWidth) {
      return
    }

    this.element.classList.add('article-content-table--scrollable')

    if (this.table.scrollLeft === 0) {
      this.element.classList.add('article-content-table--scroll-start')
    } else if (this.table.scrollLeft === (this.table.scrollWidth - this.richtext.offsetWidth)) {
      this.element.classList.add('article-content-table--scroll-end')
    }
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.article-content-table')) {
    element.instance = element.instance || new ArticleContentTableComponent(element)
  }
})
